module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-2.e02b0863.png";